import { timeStringToSeconds, convertSecondsToTimeString } from './timeUtils';
import { roundToNDecimalPlaces } from './mathUtils';
import { ProcessedSpeakerAnalysis } from '../types/speakers-analysis';

export const processSpeakerAnalysis = (
  speakerAnalysis: ProcessedSpeakerAnalysis,
  startTime: number
): ProcessedSpeakerAnalysis => {
  const { time_analysis, times } = speakerAnalysis;

  if (speakerAnalysis.start_offset === startTime) {
    return speakerAnalysis;
  }

  if (!time_analysis || !times || time_analysis.length === 0 || times.length === 0) {
    return {
      ...speakerAnalysis
    };
  }
  const differenceInStartTime = startTime - (speakerAnalysis.start_offset ?? 0);

  const paddedTimes = time_analysis.map(entry =>
    roundToNDecimalPlaces(differenceInStartTime + timeStringToSeconds(entry.time), 4)
  );

  const paddedTimeAnalysis = time_analysis.map((entry, index) => ({
    ...entry,
    time: convertSecondsToTimeString(paddedTimes[index])
  }));

  return {
    ...speakerAnalysis,
    times: paddedTimes,
    start_offset: startTime,
    time_analysis: paddedTimeAnalysis
  };
};
